export const UI_MODAL_CLOSE = 'UI_MODAL_CLOSE';
export const UI_MODAL_OPEN = 'UI_MODAL_OPEN';
export const UI_MENTION_INTEGRATION_PROMPT_HIDE =
  'UI_MENTION_INTEGRATION_PROMPT_HIDE';
export const UI_STICKY_TOC_PREFERRED_SET = 'UI_STICKY_TOC_PREFERRED_SET';
export const UI_TOPIC_DESCRIPTION_TOGGLE = 'UI_TOPIC_DESCRIPTION_TOGGLE';
export const UI_TOPIC_POSTS_ORDER_BY_CHANGED =
  'UI_TOPIC_POSTS_ORDER_BY_CHANGED';
export const UI_TEMPLATES_ORDER_BY_CHANGED = 'UI_TEMPLATES_ORDER_BY_CHANGED';
export const UI_RIGHT_PANEL_CLOSE = 'UI_RIGHT_PANEL_CLOSE';
export const UI_RIGHT_PANEL_OPEN = 'UI_RIGHT_PANEL_OPEN';
export const UI_SIDEBAR_TOGGLE = 'UI_SIDEBAR_TOGGLE';
export const UI_SIDEBAR_TOGGLE_SECTION = 'UI_SIDEBAR_TOGGLE_SECTION';
export const UI_ORGANIZATION_SUMMARY_COLLAPSED =
  'UI_ORGANIZATION_SUMMARY_COLLAPSED';
export const UI_USER_PROFILE_COLLAPSED = 'UI_USER_PROFILE_COLLAPSED';
export const UI_TOAST_CLEAR = 'UI_TOAST_CLEAR';
export const UI_TOAST_PUSH = 'UI_TOAST_PUSH';
export const UI_TOAST_REMOVE = 'UI_TOAST_REMOVE';
export const UI_TOPIC_TOGGLE = 'UI_TOPIC_TOGGLE';
export const UI_HELP_MENU_OPEN_CHANGED = 'UI_HELP_MENU_OPEN_CHANGED';
export const UI_HELP_MENU_OPEN_TOGGLED = 'UI_HELP_MENU_OPEN_TOGGLED';
export const UI_POST_TOPIC_SELECT_OPEN_CHANGED =
  'UI_POST_TOPIC_SELECT_OPEN_CHANGED';
export const UI_HELP_MENU_VISIBLE_CHANGED = 'UI_HELP_MENU_VISIBLE_CHANGED';
export const UI_RECENTLY_USED_EMOJIS_ADDED = 'UI_RECENTLY_USED_EMOJIS_ADDED';
export const UI_RECENTLY_VIEWED_POSTS_ADDED = 'UI_RECENTLY_VIEWED_POSTS_ADDED';
export const UI_RECENTLY_VIEWED_POSTS_REMOVED =
  'UI_RECENTLY_VIEWED_POSTS_REMOVED';
export const UI_EMOJI_SKIN_TONE_CHANGED = 'UI_EMOJI_SKIN_TONE_CHANGED';
export const UI_CODE_BLOCK_SYNTAX_CHANGED = 'UI_CODE_BLOCK_SYNTAX_CHANGED';
export const UI_INTEGRATION_BANNER_HIDE = 'UI_INTEGRATION_BANNER_HIDE';
export const UI_CLOSE_PLATFORM_TAB = 'UI_CLOSE_PLATFORM_TAB';
export const UI_DISMISS_SEARCH_CONNECTION_PROMPT =
  'UI_DISMISS_SEARCH_CONNECTION_PROMPT';
export const UI_ADD_USED_TEMPLATE = 'UI_ADD_USED_TEMPLATE';
export const UI_ADD_MENTIONED_USER = 'UI_ADD_MENTIONED_USER';
export const UI_SET_EXTERNAL_TOPBAR_LOGIN_REDIRECT_PATH =
  'UI_SET_EXTERNAL_TOPBAR_LOGIN_REDIRECT_PATH';
export const UI_SET_EXTERNAL_POSTS_ORDER = 'UI_SET_EXTERNAL_POSTS_ORDER';
export const UI_SET_DRAFTS_ORDER = 'UI_SET_DRAFTS_ORDER';
